export const emailRegExp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const onlyNumbersReg = /^\d+$/;
export const onlyCharacters = /^[A-Za-z]+$/;
export const onlyCharactersName = /^((?:[A-Za-z]+ ?){1,3})$/;
